module.exports = __webpack_public_path__ + "1ad797c1837bd27077560e5c9ee3181c.png";